<template>
  <div style="padding: 20px; background-color: #fafafa;">
    <!-- Header -->
    <div class="mb-6" style="display: flex; align-items: center;">
      <v-icon color="pink" size="32" class="mr-3">mdi-chart-line</v-icon>
      <div>
        <h1 class="text-h4 font-weight-bold mb-1">{{ $t('cockpit.summary.title') }}</h1>
        <p class="text-subtitle-1 text--secondary">{{ $t('cockpit.summary.subtitle') }}</p>
      </div>
    </div>

    <div class="stats-grid mb-4">
      <v-card class="stats-card pink-gradient">
        <div class="card-content">
          <v-avatar color="rgba(255,255,255,0.2)" size="48" class="mr-3">
            <v-icon color="white" size="24">mdi-account-group</v-icon>
          </v-avatar>
          <div>
            <h2 class="text-h4 white--text font-weight-bold">{{ stats.activeUsers }} / {{ stats.totalUsers }}</h2>
            <p class="white--text">{{ $t('cockpit.summary.activeUsers') }}</p>
          </div>
        </div>
      </v-card>

      <v-card class="stats-card purple-gradient">
        <div class="card-content">
          <v-avatar color="rgba(255,255,255,0.2)" size="48" class="mr-3">
            <v-icon color="white" size="24">mdi-login</v-icon>
          </v-avatar>
          <div class="flex-grow-1">
            <h2 class="text-h4 white--text font-weight-bold">{{ stats.connections }}</h2>
            <p class="white--text">{{ $t('cockpit.summary.connections') }}</p>
          </div>
        </div>
      </v-card>

      <v-card class="stats-card blue-gradient">
        <div class="card-content">
          <v-avatar color="rgba(255,255,255,0.2)" size="48" class="mr-3">
            <v-icon color="white" size="24">mdi-play-circle</v-icon>
          </v-avatar>
          <div>
            <h2 class="text-h4 white--text font-weight-bold">{{ stats.videoViews }}</h2>
            <p class="white--text">{{ $t('cockpit.summary.videoViews') }}</p>
          </div>
        </div>
      </v-card>

      <v-card class="stats-card indigo-gradient">
        <div class="card-content">
          <v-avatar color="rgba(255,255,255,0.2)" size="48" class="mr-3">
            <v-icon color="white" size="24">mdi-eye</v-icon>
          </v-avatar>
          <div>
            <h2 class="text-h4 white--text font-weight-bold">{{ stats.courseViews }}</h2>
            <p class="white--text">{{ $t('cockpit.summary.courseViews') }}</p>
          </div>
        </div>
      </v-card>
    </div>

    <v-card class="top-user-card">
      <div class="card-content">
        <v-avatar class="gradient-avatar mr-4" size="56">
          <v-icon color="white" size="28">mdi-crown</v-icon>
        </v-avatar>
        <div class="flex-grow-1">
          <div class="d-flex align-center mb-1">
            <h3 class="text-h6 font-weight-bold">{{ $t('cockpit.summary.topUserTitle') }}</h3>
          </div>
          <h2 class="text-h5 font-weight-bold mb-1">{{ topUser.firstName }} {{ topUser.lastName }}</h2>
        </div>
        <v-chip color="pink" text-color="white">
          <v-icon color="white" class="mr-1" size="18">mdi-play-circle</v-icon>
            <span class="text-subtitle-1">{{ topUser.views }} {{ $t('cockpit.summary.topUserViews') }}</span>
        </v-chip>
      </div>
    </v-card>
  </div>
</template>

<script>
import Api from "@/core/services/api.service";

export default {
  name: "synthese",
  data: () => ({
    loading: true,
    stats: { activeUsers: 0, totalUsers: 0, connections: 0, videoViews: 0, courseViews: 0 },
    topUser: { firstName: '', lastName: '', views: 0 }
  }),
  methods: {
    getDataCockpit() {
      this.loading = true;
      Api.post("cockpit-summary").then(response => {
        if (response.data.status === 'success') {
          const data = response.data.data;
          this.stats = {
            activeUsers: data.activeUsers,
            totalUsers: data.totalUsers,
            connections: data.connections,
            videoViews: data.videoViews,
            courseViews: data.courseViews
          };
          this.topUser = {
            firstName: data.topUser.firstname,
            lastName: data.topUser.lastname,
            views: data.topUser.videosSeen
          };
        }
        this.loading = false;
      }).catch(error => {
        console.error("Erreur:", error);
        this.loading = false;
      });
    }
  },
  mounted() { this.getDataCockpit(); }
};
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  max-width: 700px;
  margin: 0 auto;
}

.stats-card, .top-user-card {
  border-radius: 16px !important;
  cursor: pointer;
}


.card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.pink-gradient { background: linear-gradient(135deg, #E91E63, #AD1457) !important; }
.purple-gradient { background: linear-gradient(135deg, #9C27B0, #6A1B9A) !important; }
.blue-gradient { background: linear-gradient(135deg, #2196F3, #1565C0) !important; }
.indigo-gradient { background: linear-gradient(135deg, #3F51B5, #283593) !important; }

.top-user-card {
  background: linear-gradient(135deg, #ffffff, #f8f9fa) !important;
  border: 2px solid #e3f2fd;
  max-width: 700px;
  margin: 0 auto;
}

.gradient-avatar {
  background: linear-gradient(135deg, #FFD700, #FFA000) !important;
}

@media (max-width: 768px) {
  .summary-container { padding: 16px; }
  .stats-grid { 
    grid-template-columns: 1fr;
    max-width: 100%;
  }
  .card-content { 
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }
  .stats-card .mr-3, .top-user-card .mr-4 { margin-right: 0 !important; margin-bottom: 12px; }
}
</style>